import { render, staticRenderFns } from "./PlataformaCrear.vue?vue&type=template&id=170930e5&scoped=true"
import script from "./PlataformaCrear.vue?vue&type=script&lang=js"
export * from "./PlataformaCrear.vue?vue&type=script&lang=js"
import style0 from "./PlataformaCrear.vue?vue&type=style&index=0&id=170930e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170930e5",
  null
  
)

export default component.exports